import React, { useEffect } from "react";
import StoredLayout from "../../../layouts/StoredLayout";
import { setJumbotronTitle } from "../../../actions/common";
import WithAjax from "../../common/helpers/WithAjax";
import { connect } from "react-redux";
import { AdminMessagesTable } from "./components/AdminMessagesTable/AdminMessagesTable";

const AdminMessagesPage = (props) => {
  useEffect(() => {
    props.setJumbotronTitle("Messages");
  }, []);

  return (
    <div style={{ padding: "0px 20px" }}>
      <AdminMessagesTable ajax={props.ajax} initialFilter={undefined} />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({
  setJumbotronTitle(title) {
    dispatch(setJumbotronTitle(title));
  },
});

export default StoredLayout(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WithAjax(AdminMessagesPage))
);
